/** @format */

import React from 'react';
import './styles.scss';
import FmLightLogo from 'assets/images/logos/logo-fria-maklare-light.svg';

const PageLoader = ({ display = true }) => {
  if (display) {
    return (
      <div className='page-loader animate'>
        <img src={FmLightLogo} />
      </div>
    );
  }

  return <></>;
};

export default PageLoader;
